module.exports = __webpack_public_path__ + "b188588d4d2e2bd535cae70b31b232cc.jpg";